/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import requestDefault from '@/shared/utils/request';
import type {
  IBankData, BindCardResultEnum,
  IBindApplyQuery,
  IBindQuickBankListParams,
} from './types';
import { ContractData } from '../contract/types';

/**
 * 快捷绑卡银行列表
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/330313
 * 接口服务: 朱锐
 */
export const bindQuickBankList = (params: IBindQuickBankListParams):
  Promise<{ bankList: IBankData[] }> => requestDefault.postGate(
  'f.bind.quick.bank.list',
  { ...params },
  {
    showErrMsg: undefined,
  },
);

/**
 * 快捷绑卡申请
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/330335
 * 接口服务: 朱锐
 */
export const cardQuickBindApply = (params: IBindApplyQuery):
  Promise<{ jumpUrl: string }> => requestDefault.postGate(
  'f.card.quick.bind.apply',
  { ...params },
);

/**
 * 快捷绑卡结果查询
 * yapi地址: https://yapi.hellobike.cn/project/3415/interface/api/330351
 * 接口服务: 朱锐
 */
export const cardQuickBindQuery = (params: {
  bankCardNo: string,
  thirdCardApplyNo: string,
  cardApplyId: string
}):
Promise<{ bankCardId: string, result: BindCardResultEnum }> => requestDefault.postGate(
  'f.card.quick.bind.query',
  params,
  {
    showLoading: undefined,
  },
);

/**
 * 快捷绑卡-协议列表
 * yapi: https://yapi.hellobike.cn/project/3415/interface/api/85017
 */
export const commodityContractList = (params: {
  bankCode: string,
  commodityId: number,
  capitalCode?: string,
}):
Promise<ContractData[]> => requestDefault.postGate(
  'f.contract.mgetCommodity',
  {
    ...params,
    type: 'full.product.3.quick.bind',
  },
);
